import React, { useMemo } from 'react'
import {useTranslation} from 'react-i18next'
import * as Yup from "yup";
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';

import './LoginForm.scss';
import { Form } from "../../components/Form";
import { CircularProgress } from "@mui/material";
import {ILoginFormValues} from "./types";

const LoginForm = ({handleSubmit}): JSX.Element => {
  const { t } = useTranslation();
  const validationSchema = useMemo(
    () =>
      Yup.object().shape({
        email: Yup.string().required(t('validation.emailRequired')),
        password: Yup.string().required(t('validation.passwordRequired')),
       }),
    [t]
  );
  
  return (
    <Form.Context<ILoginFormValues>
      initialValues={{}}
      isInitialValid={false}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {({ handleSubmit, isValid, isSubmitting }) => (
        <Form.Form onSubmit={handleSubmit}>
          <Grid sx={{marginTop: '1rem'}} container spacing={2}>
            <Grid item xs={12}>
              <Form.TextField
                id="email"
                label={t('auth.usernameOrEmail')}
                name="email"
                autoComplete="email"
              />
            </Grid>
            <Grid item xs={12}>
              <Form.TextField
                id="password"
                label={t('auth.password')}
                name="password"
                type="password"
                autoComplete="password"
              />
            </Grid>
          </Grid>
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
            disabled={!isValid}
          >
            {isSubmitting ? <CircularProgress color="inherit" size={24}/> : t('auth.login')}
          </Button>
        </Form.Form>
      )}
    </Form.Context>
  );
}
export default LoginForm
